import {
    makeHttpRequest,
    mapDatabaseParamsFromServer,
    mapPaginationParamsToServer,
} from "@/shared";

import { mapRefusalTypesFromServer } from "./mappers/mapRefusalTypesFromServer";

export const getRefusalTypes = async (paginationParams = {}) => {
    const response = (
        await makeHttpRequest({
            url: "/delivery/refusal-type",
            method: "GET",
            params: mapPaginationParamsToServer(paginationParams),
        })
    ).data;

    return {
        data: mapRefusalTypesFromServer(response.data),
        ...mapDatabaseParamsFromServer(response),
    };
};
